export default function PlayingCardsIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path d="M14.4 15.243L13.7 11.706L16.696 9.69995L17.397 13.237L14.4 15.243Z"></path>
                <path d="M23.4979 7.64628L13.335 3.43768L7.59566 17.2971L17.7586 21.5057L23.4979 7.64628Z"></path>
                <path d="M16.867 18.4301L16.215 18.7021L16.483 19.3541L17.139 19.0841L16.867 18.4301Z"></path>
                <path d="M14.61 5.58899L13.958 5.85999L14.229 6.51399L14.881 6.24099L14.61 5.58899Z"></path>
                <path d="M2.921 8.05798L2.651 8.71298L3.304 8.98198L3.575 8.32998L2.921 8.05798Z"></path>
                <path d="M2.921 8.05798L2.651 8.71298L3.304 8.98198L3.575 8.32998L2.921 8.05798Z"></path>
                <path d="M8 17.438H6.5V2.5H17.5V4.938"></path>
                <path d="M11.747 19.016L6.24 21.297L0.5 7.43795L6.505 4.94995"></path>
                <path d="M9.01823 4.3677L8.65054 4L8.28284 4.3677L8.65054 4.73539L9.01823 4.3677Z"></path>
            </g>
        </svg>
    )
}